<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'app#city_card#pos_map#title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goToList()">
        <ion-icon slot="icon-only" name="list-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <div class="map-wrapper">
    <div #mapContainer></div>

    @if (isLoading()) {
      <div class="map-overlay">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    }

    @if (selectedPos(); as pos) {
      <div class="pos-card">
        <div class="pos-card__header">
          <h3>{{ pos.title }}</h3>
          <ion-button fill="clear" size="small" (click)="closeCard()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </div>
        @if (pos.addresses) {
          <p class="pos-card__address">
            <ion-icon name="location-outline"></ion-icon>
            {{ pos.addresses }}
          </p>
        }
        <ion-button expand="block" size="small" (click)="goToDetail(pos.id!)">
          {{ 'app#city_card#pos_map#more_info' | translate }}
        </ion-button>
      </div>
    }
  </div>
</ion-content>
